import React from 'react';
import usePermissionCheck from 'utils/hooks/usePermissionCheck';
import CentralizedSpinner from 'components/CentralizedSpinner';
import AgroLayout from 'components/Layout/Meteorology/Agro';

export default function AgroWrapper() {
  const keySaved = usePermissionCheck('agro');

  if (!keySaved) {
    return <CentralizedSpinner />;
  }

  return <AgroLayout />;
}
